import classnames from 'classnames'
import { CSSProperties } from 'react'
import { RichText, RichTextProps } from '../../molecules/RichText'
import Image, { ImageProps } from '../image/Image'

import styles from './imageWithText2.module.scss'

export enum CONTENT_SIDE {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface ImageWithText2Props {
  sideImage: ImageProps
  styleObject: CSSProperties
  headingRichTextContent?: RichTextProps
  descriptionRichTextContent?: RichTextProps
  type?: CONTENT_SIDE
  className?: string
}

export const ImageWithText2 = ({ className = '', type = CONTENT_SIDE.LEFT, ...props }: ImageWithText2Props) => {
  const wraperClasses = classnames(styles.imageWithText2Wrap, styles[`content__${type}`], className)

  const contentDivClasses = classnames(styles.contentDiv, 'colour--black font-line-height--3')

  return (
    <div style={props.styleObject} className={wraperClasses}>
      {(props.headingRichTextContent || props.descriptionRichTextContent) && (
        <div className={contentDivClasses}>
          {props.headingRichTextContent && (
            <RichText className={classnames(styles.image_with_content_title)} {...props.headingRichTextContent} />
          )}
          {props.descriptionRichTextContent && (
            <RichText className={classnames(styles.image_with_content_text)} {...props.descriptionRichTextContent} />
          )}
        </div>
      )}
      {props.sideImage.url && (
        <div className={styles.RightContent}>
          <Image {...props.sideImage} className={styles.slideImage} alt={props.sideImage.description} />
        </div>
      )}
    </div>
  )
}

export default ImageWithText2
